import { GatheringViewMode } from "../types";

const ValidCaptureTimeViewModes = new Set<GatheringViewMode>(["All", "Filter"]);
export default ValidCaptureTimeViewModes;
